<template>
  <b-button
    size="md"
    variant="link"
    :style="{ backgroundColor: '#FF5252', color: '#FFFFFF' }"
    class="ml-3"
    @click="performAction"
  >
    <i class="fa fa-close" />
    Reject report
  </b-button>
</template>

<script lang="ts">
import { notify } from '@kyvg/vue3-notification'
import { computed, defineComponent } from 'vue'
import { openModal } from '@/services/Modal'
import { useAccountStore } from '@/store/account'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'

export default defineComponent({
  name: 'RejectReport',
  setup() {
    const accountStore = useAccountStore()
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const isStaff = computed(() => accountStore.isStaff)

    const performAction = () => {
          openModal('confirmWrap', {
            title: 'Are you sure you want to reject report?',
            message: isStaff.value
              ? 'Report will be rejected on behalf of the client'
              : 'This is an irreversible action. You will not be able to proceed after the report is rejected.',
            okButtonText: 'Reject',
            onConfirm: () => {
          assignmentSummaryStore.submitReportDeny().then(() => {
              notify({ group: 'success', text: 'Report has been rejected' })
            })
          },
        })
    }

    return {
      performAction,
    }
  },
})
</script>
